module.exports = __webpack_public_path__ + "static/media/ko.2753a02c.png";